import * as ApiManager from './_manager';
import store from '../store';

export const company = {
  create: payload => {
    return ApiManager.callApi ('/member/company/create', payload);
  },

  get: payload => {
    return ApiManager.callApi ('/member/company/get', payload);
  },

  delete: payload => {
    return ApiManager.callApi ('/member/company/delete', payload);
  },

  update: payload => {
    return ApiManager.callApi ('/member/company/update', payload);
  },

  getMembers: payload => {
    return ApiManager.callApi ('/member/company/getMembers', payload);
  },

  addMember: payload => {
    return ApiManager.callApi ('/member/company/addMember', payload);
  },

  removeMember: payload => {
    return ApiManager.callApi ('/member/company/removeMember', payload);
  },

  list: payload => {
    return ApiManager.callApi (
      `/member/company/list${payload && payload.page ? '?page='+payload.page :''}`,
      payload
    );
  },
  recentActivities: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/recentActivities`,
      payload
    );
  },

  getGapiToken: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/gapi_token/get`,
      payload
    );
  },

  setGapiToken: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/gapi_token/set`,
      payload
    );
  },
  resetGapiToken: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/gapi_token/delete`,
      payload
    );
  },

  getMailchimpLists: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/mailchimpLists/list`,
      payload
    );
  },

  updatePaymentMethod: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/updatePaymentMethod`,
      payload
    );
  },

  buyAddons: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/buyAddons`,
      payload
    );
  },

  markAddonPurchased: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/markAddonPurchased`,
      payload
    );
  },

  listTransaction: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/listTransaction`,
      payload
    );
  },

  generateNewOAuthSecret: payload => {
    return ApiManager.callApi (`/member/company/${payload.id}/generateNewOAuthSecret`, payload.oauth_settings);
  },

  updateWhitelabelDomain: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/updateWhitelabelDomain`,
      payload
    )
  },
  
  listPaymentGateways : payload => {
    return ApiManager.callApi (
        `/guest/company/${payload.company_id}/listPaymentGateways`,
         payload
    );
  },
  
  listSubscription: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/listSubscription`,
      payload
    );
  },

  listCustomEmail: payload => {
    return ApiManager.callApi (`/member/company/${payload.company_id}/customEmail/list`, payload);
  },

  createCustomEmail: payload => {
    return ApiManager.callApi (`/member/company/${payload.company_id}/customEmail/create`, payload);
  },

  updateCustomEmail: payload => {
    return ApiManager.callApi (`/member/company/${payload.company_id}/customEmail/${payload.id}/update`, payload);
  },
};
